import { render, staticRenderFns } from "./DialogBriefcaseSelector.vue?vue&type=template&id=6571f724"
import script from "./DialogBriefcaseSelector.vue?vue&type=script&lang=js"
export * from "./DialogBriefcaseSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports